/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Legacy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddOrRemoveClientRequest
 */
export interface AddOrRemoveClientRequest {
    /**
     * 
     * @type {number}
     * @memberof AddOrRemoveClientRequest
     */
    activityId: number;
    /**
     * 
     * @type {number}
     * @memberof AddOrRemoveClientRequest
     */
    contactId?: number;
    /**
     * 
     * @type {string}
     * @memberof AddOrRemoveClientRequest
     */
    addressId?: string;
}

export function AddOrRemoveClientRequestFromJSON(json: any): AddOrRemoveClientRequest {
    return AddOrRemoveClientRequestFromJSONTyped(json, false);
}

export function AddOrRemoveClientRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddOrRemoveClientRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'activityId': json['activityId'],
        'contactId': !exists(json, 'contactId') ? undefined : json['contactId'],
        'addressId': !exists(json, 'addressId') ? undefined : json['addressId'],
    };
}

export function AddOrRemoveClientRequestToJSON(value?: AddOrRemoveClientRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'activityId': value.activityId,
        'contactId': value.contactId,
        'addressId': value.addressId,
    };
}


